import * as React from 'react';

const Preloader = () => {
    return (
        <div
            className={'preloader'}
        >
            <img
                className={'preloader__img'}
                src={'assets/images/logo.png'}
            />
        </div>
    );
};

export default Preloader;
